
<template>
  <div  class="root-container">

    <el-row>
      <el-col :span="6"  >
        <el-row>
          <el-col :span="10"><div style="margin-top: 10px;margin-left: 30px">选择模板:</div></el-col>
          <el-col :span="14">
            <el-select v-model="queryParam.name" placeholder="请选择" @change="onChaneTemplate">
              <el-option
                v-for="item in allScheTemplates"
                :key="item.id"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
          </el-col>
        </el-row>
      </el-col>
    </el-row>

    <el-row>
      <el-col :span="3"><div class="grid-content bg-purple">
      </div></el-col>
      <!--周几-->
      <div v-for="item in templateNameData.schedulingData" :key="item.date" >
        <el-col :span="3"><div class="grid-content bg-purple-light"> {{item.dateDes}}</div></el-col>
      </div>
    </el-row>

    <el-row>
      <el-col :span="3"><div class="grid-content bg-purple">
      </div></el-col>
      <!--上午排班-->
      <div v-for="item in templateNameData.schedulingData"  :key="item.date" >
        <el-col :span="3"><div class="grid-content bg-purple-light">

          <!--一天的上午排课-->
          <div  v-for="(item,timeIndex) in item.timeRangMorning" :key="item.id" >
            <el-card  class="class-s-card">

              <el-row  class="class-s-card-lesson" >
                {{item.lesson.name}}
              </el-row>
              <div class="line"></div>
              <el-row  class="class-s-card-lesson" >
                {{item.type}}
              </el-row>
              <div class="line"></div>
              <el-row  class="class-s-card-time" >
                {{item.startTime}} - {{item.endTime}}
              </el-row>
              <el-row  class="class-s-card-children" >
                容纳量:{{item.maxNum}}
              </el-row>

              <div class="line"></div>
              <el-row  class="class-s-card-worker" >
                <div v-for="worker in item.workers">
                  <el-col :span="12" style="margin-top: 5px">
                    {{worker.name}}
                  </el-col>
                </div>
              </el-row>
              <el-button  size="mini"  @click="handleDeleteOne(item,1,dayIndex,timeIndex)" style="margin-top: 10px">删除时间段</el-button>
            </el-card>
          </div>

        </div></el-col>
      </div>
    </el-row>


    <el-row>
      <el-col :span="3"><div class="grid-content bg-purple">
      </div></el-col>
      <!--下午排班-->
      <div v-for="item in templateNameData.schedulingData"  :key="item.date" >
        <el-col :span="3"><div class="grid-content bg-purple-light">

          <!--一天的下午排课-->
          <div  v-for="(item,timeIndex) in item.timeRangAfternoon" :key="item.id" >
            <el-card  class="class-s-card">

              <el-row  class="class-s-card-lesson" >
                {{item.lesson.name}}
              </el-row>
              <div class="line"></div>
              <el-row class="class-s-card-lesson" >
                {{item.type}}
              </el-row>
              <div class="line"></div>
              <el-row  class="class-s-card-time" >
                {{item.startTime}} - {{item.endTime}}
              </el-row>
              <el-row  class="class-s-card-children" >
                容纳量:{{item.maxNum}}
              </el-row>
              <div class="line"></div>
              <el-row  class="class-s-card-worker" >
                <div v-for="worker in item.workers">
                  <el-col :span="12" style="margin-top: 5px">
                    {{worker.name}}
                  </el-col>
                </div>
              </el-row>
              <el-button  size="mini"  @click="handleDeleteOne(item,2,dayIndex,timeIndex)" style="margin-top: 10px">删除时间段</el-button>
            </el-card>
          </div>

        </div></el-col>
      </div>
    </el-row>

  </div>


</template>

<style scoped>

  .el-row {
    margin-bottom: 20px;
  &:last-child {
     margin-bottom: 0;
   }
  }
  .el-col {
    border-radius: 4px;
  }
  .bg-purple-dark {
    background: #99a9bf;
  }
  .bg-purple {
    background: #d3dce6;
  }
  .bg-purple-light {
    background: #e5e9f2;
  }
  .grid-content {
    border-radius: 4px;
    min-height: 36px;
  }
  .row-bg {
    padding: 10px 0;
    background-color: #f9fafc;
  }


</style>

<script>


  import globaldata from "../../../../utils/globaldata";
  import commonUtils from "../../../../utils/commonUtils";
  import timeUtils from "../../../../utils/timeUtils";
  import {selectSchedule} from "../../../../api/scheduleTimeTemplate";

  export default {
    name: 'SchedulingFC',
    data() {
      return {

        //所有员工
        allWorker:[

        ],

        allScheTemplates:[

        ],
        queryParam:{
          name:""
        },
        //店铺等级课程
        storeLevelLesson:[],
        //店铺可以使用的模板课程
        storeLessons:[],
        templateNameData:{
          id:null,
          name:"",//模板名称
          schedulingData:[
            {
              id:null,
              dateDes:'周一',
              dayIndex: 0,
              scheduleTimeTemplateId:null,
              timeRangMorning:[

              ],

              timeRangAfternoon:[

              ]

            },
            {
              id:null,
              dateDes:'周二',
              dayIndex: 1,
              scheduleTimeTemplateId:null,
              timeRangMorning:[

              ],
              timeRangAfternoon:[

              ]

            },
            {
              id:null,
              dateDes:'周三',
              dayIndex: 2,
              scheduleTimeTemplateId:null,
              timeRangMorning:[

              ],

              timeRangAfternoon:[

              ]

            },
            {
              id:null,
              dateDes:'周四',
              dayIndex: 3,
              scheduleTimeTemplateId:null,
              timeRangMorning:[

              ],
              timeRangAfternoon:[

              ]

            },
            {
              id:null,
              dateDes:'周五',
              dayIndex: 4,
              scheduleTimeTemplateId:null,
              timeRangMorning:[

              ],
              timeRangAfternoon:[

              ]

            },
            {
              id:null,
              dateDes:'周六',
              dayIndex: 5,
              scheduleTimeTemplateId:null,
              timeRangMorning:[

              ],
              timeRangAfternoon:[

              ]

            },
            {
              id:null,
              dateDes:'周日',
              dayIndex: 6,
              scheduleTimeTemplateId:null,
              timeRangMorning:[
              ],
              timeRangAfternoon:[
              ]
            }

          ],
        },

      }
    },
    created(){
      globaldata.getStoreScheduingTempLate(this.getStoreScheduingTempLate);
      globaldata.getStoreWorkersInfo(this.getStoreWorkersInfo);
      globaldata.getStoreLevelLesson(this.getStoreLevelLesson);
      globaldata.getStoreLessonTemplate(this.getStoreLessonTemplate);
    },
    mounted() {

    },
    methods: {
      getStoreWorkersInfo(list){
        this.allWorker = list;
      },
      getStoreLevelLesson(data){
        this.storeLevelLesson =data;
      },
      getStoreLessonTemplate(list){
        this.storeLessons = list;
      },

      getStoreScheduingTempLate(list){
        this.allScheTemplates = list;
        this.allScheTemplates.push(
          {
            id:null,
            name:"添加新模板",
          }
        )
      },


      // 查询一个模板信息

      onChaneTemplate(val){

        console.log("onChaneTemplate",val)
        if (val == null){
          //创建新模板
          this.resetData();
          return;
        }
        if (val>0){
          let param  = {
            id:val
          }
          selectSchedule(param).then(response =>
          {

            let  data = response.data;
            if (!commonUtils.isObjectNull(data)){
              this.refreshData(data)
            }
          })
        }
      },
      /**
       * 重置一下数据
       */
      resetData(){
        this.templateNameData.id = null;
        this.templateNameData.name = "";
        this.queryParam.name = "";
        for (let i =0;i< this.templateNameData.schedulingData.length;++i){
          this.templateNameData.schedulingData[i].id = null;
          this.templateNameData.schedulingData[i].scheduleTimeTemplateId = null;
          this.templateNameData.schedulingData[i].timeRangMorning = [];
          this.templateNameData.schedulingData[i].timeRangAfternoon = [];
        }
      },

      /**
       * 刷新模板数据
       */
      refreshData(data){
        this.resetData();
        let list = data.list;
        this.templateNameData.name = data.name;
        this.templateNameData.id = data.id;
        this.queryParam.name = data.name;
        for (let i =0;i< this.templateNameData.schedulingData.length;++i){
          let schedulingData = this.templateNameData.schedulingData[i];
          schedulingData.timeRangMorning = [];
          schedulingData.timeRangAfternoon = [];
          schedulingData.id = list[i].id;
          schedulingData.dayIndex = list[i].dayIndex;
          schedulingData.scheduleTimeTemplateId = list[i].scheduleTimeTemplateId;
          let dayIndexData = this.getDayIndexData(list,schedulingData.dayIndex);
          if (commonUtils.isObjectNull(dayIndexData)){
            continue;
          }
          //将数据刷新到
          let times =  JSON.parse(dayIndexData.times);
          for (let i = 0;i<times.length;++i){
            let ar = times[i].timeRange.split("_");
            if (commonUtils.isObjectNull(ar) || ar.length !=2){
              continue;
            }

            let startSort =  timeUtils.transTimeHMInt(ar[0]);
            let lessonId  = times[i].lessonId;
            let lessonName = "";
            if (!commonUtils.isObjectNull(lessonId)){
              lessonName = this.getStoreLessonById(lessonId).lessonName;
            }

            let t = {
              lesson:{
                id:lessonId,
                name:lessonName
              },
              startSort : startSort,
              startTime:ar[0],
              endTime:ar[1],
              workers:times[i].workers,
              maxNum:times[i].maxNum,

            }
            if(startSort <1200){
              //上午
              schedulingData.timeRangMorning.push(t);
            }else {
              //下午
              schedulingData.timeRangAfternoon.push(t);
            }
          }
        }

      },

      getDayIndexData(list,dayIndex){
        for (let i =0;i<list.length;++i ){
          if (list[i].dayIndex == dayIndex){
            return list[i];
          }
        }
      },

      getStoreLessonById(id){
        for (let i = 0;i< this.storeLevelLesson.length;++i){
          if (id == this.storeLevelLesson[i].id){
            return this.storeLevelLesson[i];
          }
        }
      },


      /**
       * 删除一个课程
       * @param item
       * @param v
       * @param dayIndex
       * @param timeIndex
       */
      handleDeleteOne(item,v,dayIndex,timeIndex){

        let timeRang = null;
        if (v == 1){
          //上午
          timeRang = this.templateNameData.schedulingData[dayIndex].timeRangMorning;
        } else if (v == 2){
          //下午
          timeRang = this.templateNameData.schedulingData[dayIndex].timeRangAfternoon;
        }
        timeRang.splice(timeIndex,1);
      },

    }
  }
</script>






// WEBPACK FOOTER //
// src/views/my-store/scheduling-template/components/SchedulingFC.vue